<template lang="pug">
    v-container(fluid grid-list-md)
        v-overlay(:value="deleting")
            v-progress-circular(indeterminate size="64")
        v-layout(wrap align-center)
            page-title(:title="$t('pages.settings.calendar.title')" :icon="pageIcons.calendar")
            search-box(v-model="search" :loading="loading" @search="onSearch" @setting="showAdvanceSearchDialog"
                :search-label="$t('pages.settings.calendar.labelSearch')"
                :advance-search-hint="$t('pages.settings.calendar.searchConfigHint')")
            add-new-button(:caption="$t('pages.settings.calendar.buttonAdd')" :disabled="loading" @click="newItem")

            v-flex(xs12)
                .subtitle-1.font-weight-medium {{$t('general.shortcut')}}

            v-flex(xs12 tag="v-card" mt-2)
                v-data-table(:headers="headers" :items="favoriteItems" :mobile-breakpoint="50"
                    :footer-props="{ showFirstLastPage: true, showCurrentPage: true }" @update:options="onChangeOptionsFavorite"
                    :options.sync="favoriteOptions" :server-items-length="favoriteTotal" multi-sort)
                    template(#top)
                        v-layout(column mx-auto pa-3)
                            .body-2 ผลลัพธ์ <b>{{favoriteTotal}}</b> รายการ&nbsp;&nbsp;
                                span(v-if="favoriteSortByKeys.length") เรียงตาม&nbsp;&nbsp;
                                    v-chip.mr-2.font-weight-medium.primary--text(v-for="column in favoriteSortByKeys" close @click:close="onRemoveSortChip(column, 'favoriteOptions')").my-1
                                        v-icon(left @click="onToggleSort(column, 'favoriteOptions')") {{favoriteSortBy[column] === 'desc' ? 'mdi-arrow-down-circle-outline' : 'mdi-arrow-up-circle-outline'}}
                                        span {{$t(`pages.settings.calendar.sortedChip['${column}']`)}}
                    template(#item.title='{ value }')
                        .div(style="white-space: nowrap;") {{value}}
                    template(#item.link='{ value }')
                        .div(style="white-space: nowrap;") {{value}}
                    template(#item.action='{ item }')
                        v-layout(pa-0 ma-0 justify-center)
                            v-btn(icon @click='toggleFavorite(item)')
                                v-icon(:color="item.favorite ? 'warning' : ''") mdi-star-outline
                            v-btn(icon @click='editItem(item)')
                                v-icon mdi-pencil-outline
                            v-btn(icon @click='deleteItem(item)')
                                v-icon mdi-delete-outline
                    template(#item.status='{ value }')
                        v-chip(:color="value ? 'green' : 'red'" dark)
                            v-icon(left) {{value ? 'mdi-check' : 'mdi-cancel'}}
                            | {{$t(`pages.settings.calendar.table.headers.status.values[${value}]`)}}

            v-flex(xs12 mt-2)
                .subtitle-1.font-weight-medium {{$t('general.all')}}

            v-flex(xs12 tag="v-card" mt-2)
                v-data-table(:headers="headers" :items="items" :mobile-breakpoint="50"
                    :footer-props="{ showFirstLastPage: true, showCurrentPage: true }" @update:options="onChangeOptions"
                    :loading="loading" :options.sync="options" :server-items-length="total" multi-sort)
                    template(#top)
                        v-layout(column mx-auto pa-3)
                            .body-2 ผลลัพธ์ <b>{{total}}</b> รายการ&nbsp;&nbsp;
                                span(v-if="keyword") คำค้น&nbsp;&nbsp;
                                    v-chip.mr-2.font-weight-medium.primary--text(close @click:close="onRemoveKeywordChip") {{keyword}}
                                span(v-if="sortByKeys.length") เรียงตาม&nbsp;&nbsp;
                                    v-chip.mr-2.font-weight-medium.primary--text(v-for="column in sortByKeys" close @click:close="onRemoveSortChip(column, 'options')").my-1
                                        v-icon(left @click="onToggleSort(column, 'options')") {{sortBy[column] === 'desc' ? 'mdi-arrow-down-circle-outline' : 'mdi-arrow-up-circle-outline'}}
                                        span {{$t(`pages.settings.calendar.sortedChip['${column}']`)}}
                                span(v-if="searchBy.length") ค้นหาจาก&nbsp;&nbsp;
                                    v-chip.mr-2.font-weight-medium.primary--text(v-for="column in searchBy" close @click:close="onRemoveSearchByChip(column, 'options')").my-1
                                        span {{$t(`pages.settings.calendar.sortedChip['${column}']`)}}
                            .body-2(v-if="filteredCompanies.length || filteredStatus.length || filteredServiceTypes.length || filteredCalendarTypes.length") ค้นหาจาก
                                span(v-if="filteredCompanies.length") บริษัท&nbsp;&nbsp;
                                    v-chip.mr-2.font-weight-medium.primary--text(v-for="company in filteredCompanies" close @click:close="onRemoveCompanyChip(company, 'options')").my-1
                                        span {{company.code}}
                                span(v-if="filteredServiceTypes.length") &nbsp;Service Type&nbsp;&nbsp;
                                    v-chip.mr-2.font-weight-medium.primary--text(v-for="type in filteredServiceTypes" close @click:close="onRemoveServiceTypeChip(type, 'options')").my-1
                                        span {{type}}
                                span(v-if="filteredCalendarTypes.length") &nbsp;Calendar Type&nbsp;&nbsp;
                                    v-chip.mr-2.font-weight-medium.primary--text(v-for="type in filteredCalendarTypes" close @click:close="onRemoveCalendarTypeChip(type, 'options')").my-1
                                        span {{type}}
                                span(v-if="filteredStatus.length") สถานะ&nbsp;&nbsp;
                                    v-chip.mr-2.font-weight-medium(v-for="status in filteredStatus" :color="status ? 'green' : 'red'"  dark close @click:close="onRemoveStatusChip(status)").my-1
                                        v-icon(left) {{status ? 'mdi-check' : 'mdi-cancel'}}
                                        span {{$t(`pages.settings.user.table.headers.status.values[${status}]`)}}
                    template(#item.status='{ value }')
                        v-chip(:color="value ? 'green' : 'red'" dark)
                            v-icon(left) {{value ? 'mdi-check' : 'mdi-cancel'}}
                            | {{$t(`pages.settings.calendar.table.headers.status.values[${value}]`)}}
                    template(#item.title='{ value }')
                        highlighter(:text="value" :keyword="keyword" v-if="searchBy.length === 0 || searchBy.includes('calendars.title')")
                        span(v-else) {{value}}
                    template(#item.company.code='{ value }')
                        highlighter(:text="value" :keyword="keyword" v-if="searchBy.length === 0 || searchBy.includes('companies.code')")
                        span(v-else) {{value}}
                    template(#item.action='{ item }')
                        v-layout(pa-0 ma-0 justify-center)
                            v-btn(icon @click='toggleFavorite(item)')
                                v-icon(:color="item.favorite ? 'warning' : ''") mdi-star-outline
                            v-btn(icon @click='editItem(item)')
                                v-icon mdi-pencil-outline
                            v-btn(icon @click='deleteItem(item)')
                                v-icon mdi-delete-outline

        advanced-search-dialog(ref="refAdvancedSearchDialog" @submit="onSearchAdvanceSubmit"
            :search-columns-label="$t('pages.settings.user.searchConfigColumns')"
            :search-companies-label="$t('pages.settings.user.searchCompanies')"
            :search-types-label="$t('pages.settings.user.table.headers.type.title')"
            :search-statuses-label="$t('pages.settings.user.table.headers.status.title')"
            :title="$t('pages.settings.user.searchConfigHint')")
        edit-dialog(ref="refEditDialog" @saved="onSaved")
</template>

<script>
import { sync, get, call } from "vuex-pathify";
import _ from "lodash";
import general from "../../mixins/general";
import crud from "../../mixins/crud";
import auth from "../../mixins/auth";

import PageTitle from "../../components/commons/PageTitle";
import AddNewButton from "../../components/commons/AddNewButton";
import SearchBox from "../../components/commons/SearchBox";
import AdvancedSearchDialog from "../../components/calendar/AdvancedSearchDialog";
import EditDialog from "../../components/calendar/EditDialog";

export default {
  name: "CalendarSetting",
  components: {
    EditDialog,
    AdvancedSearchDialog,
    SearchBox,
    AddNewButton,
    PageTitle
  },
  mixins: [auth, crud, general],
  data() {
    return {
      deleting: false,
      editing: false
    };
  },
  computed: {
    search: sync("calendars/search"),
    options: sync("calendars/options"),
    loading: get("calendars/loading"),
    loaded: get("calendars/loaded"),
    items: get("calendars/items"),
    total: get("calendars/total"),

    keyword: get("calendars/keyword"),
    searchBy: get("calendars/searchBy"),
    sortBy: get("calendars/sortBy"),
    sortByKeys: get("calendars/sortByKeys"),
    filteredCompanies: get("calendars/filteredCompanies"),
    filteredCompaniesKeys: get("calendars/filteredCompaniesKeys"),
    filteredStatus: get("calendars/filteredStatus"),

    filteredServiceTypes: get("calendars/filteredServiceTypes"),
    filteredCalendarTypes: get("calendars/filteredCalendarTypes"),
    filteredFavorite: get("calendars/filteredFavorite"),

    favoriteOptions: sync("calendars/favoriteOptions"),
    favoriteItems: get("calendars/favoriteItems"),
    favoriteTotal: get("calendars/favoriteTotal"),

    favoriteSortBy: get("calendars/favoriteSortBy"),
    favoriteSortByKeys: get("calendars/favoriteSortByKeys"),

    headers: {
      get() {
        return [
          {
            text: this.$t("pages.settings.calendar.table.headers.row.title"),
            align: "left",
            sortable: false,
            value: "row",
            class: ["body-2"]
          },
          {
            text: this.$t("pages.settings.calendar.table.headers.title.title"),
            value: "title",
            class: ["body-2"]
          },
          {
            text: this.$t(
              "pages.settings.calendar.table.headers['company.code'].title"
            ),
            align: "left",
            sortable: true,
            value: "company.code",
            class: ["body-2"]
          },
          {
            text: this.$t(
              "pages.settings.calendar.table.headers.service_type.title"
            ),
            value: "service_type",
            class: ["body-2"]
          },
          {
            text: this.$t(
              "pages.settings.calendar.table.headers.calendar_type.title"
            ),
            value: "calendar_type",
            class: ["body-2"]
          },
          {
            text: this.$t("pages.settings.calendar.table.headers.status.title"),
            value: "status",
            class: ["body-2"]
          },
          {
            text: this.$t(
              "pages.settings.calendar.table.headers.actions.title"
            ),
            align: "center",
            value: "action",
            class: ["body-2"],
            sortable: false
          }
        ];
      }
    }
  },
  methods: {
    loadAll: call("calendars/load"),
    searchHandle: call("calendars/search"),
    reload: call("calendars/reload"),
    filter: call("calendars/filter"),
    updateOptions: call("calendars/updateOptions"),
    updateOptionsFavorite: call("calendars/updateOptionsFavorite"),
    toggleSort: call("calendars/toggleSort"),
    removeColumnSorted: call("calendars/removeColumnSorted"),
    removeSearchedBy: call("calendars/removeSearchedBy"),
    removeStatusFiltered: call("calendars/removeStatusFiltered"),
    removeCompanyFiltered: call("calendars/removeCompanyFiltered"),
    removeServiceTypeFiltered: call("calendars/removeServiceTypeFiltered"),
    removeCalendarTypeFiltered: call("calendars/removeCalendarTypeFiltered"),
    removeFavoriteFiltered: call("calendars/removeFavoriteFiltered"),

    showAdvanceSearchDialog() {
      this.$refs["refAdvancedSearchDialog"].selectedColumns = _.cloneDeep(
        this.searchBy
      );
      this.$refs["refAdvancedSearchDialog"].selectedCompanies = _.cloneDeep(
        this.filteredCompaniesKeys
      );

      this.$refs["refAdvancedSearchDialog"].selectedServiceTypes = _.cloneDeep(
        this.filteredServiceTypes
      );

      this.$refs["refAdvancedSearchDialog"].selectedCalendarTypes = _.cloneDeep(
        this.filteredCalendarTypes
      );

      const filteredStatus = _.cloneDeep(this.filteredStatus);
      this.$refs["refAdvancedSearchDialog"].selectedStatuses =
        Array.isArray(filteredStatus) && filteredStatus.length > 0
          ? filteredStatus[0]
          : null;

      const selectedFavorite = _.cloneDeep(this.filteredFavorite);
      this.$refs["refAdvancedSearchDialog"].selectedFavorite =
        Array.isArray(selectedFavorite) && selectedFavorite.length > 0
          ? selectedFavorite[0]
          : null;
      this.$refs["refAdvancedSearchDialog"].show();
    },
    onSearchAdvanceSubmit(data) {
      if (!this.loading) {
        this.filter(data);
      }
    },
    onSearch() {
      if (!this.loading) {
        this.searchHandle(this.search);
      }
    },
    onChangeOptions(options) {
      if (this.loaded && !this.loading) {
        this.updateOptions(options);
      }
    },
    onChangeOptionsFavorite(options) {
      if (this.loaded && !this.loading) {
        this.updateOptionsFavorite(options);
      }
    },
    onRemoveKeywordChip() {
      if (!this.loading) {
        this.searchHandle("");
      }
    },
    onRemoveSortChip(column, src) {
      if (this.loaded && !this.loading) {
        this.removeColumnSorted({ column, src });
      }
    },
    onToggleSort(column, src) {
      if (this.loaded && !this.loading) {
        this.toggleSort({ column, src });
      }
    },
    onRemoveSearchByChip(column) {
      if (this.loaded && !this.loading) {
        this.removeSearchedBy(column);
      }
    },
    onRemoveCompanyChip(company) {
      if (this.loaded && !this.loading) {
        this.removeCompanyFiltered(company.id);
      }
    },
    onRemoveStatusChip(status) {
      if (this.loaded && !this.loading) {
        this.removeStatusFiltered(status);
      }
    },
    onRemoveServiceTypeChip(type) {
      if (this.loaded && !this.loading) {
        this.removeServiceTypeFiltered(type);
      }
    },
    onRemoveCalendarTypeChip(type) {
      if (this.loaded && !this.loading) {
        this.removeCalendarTypeFiltered(type);
      }
    },
    onRemoveFavoriteChip(type) {
      if (this.loaded && !this.loading) {
        this.removeFavoriteFiltered(type);
      }
    },
    newItem() {
      this.$refs["refEditDialog"].show("create");
    },
    editItem(item) {
      this.$refs["refEditDialog"].show("edit", item);
    },
    toggleFavorite(item) {
      this.editing = true;
      this.axios
        .put(`calendars/${item.id}/toggle-favorite`)
        .then(() => {
          this.editing = false;
          this.$toasted.info(this.$t("general.saved") + ` "${item.title}"`, {
            icon: "check"
          });
          this.reload(undefined);
        })
        .catch(error => {
          this.editing = false;
          this.updateErrorHandler(error).then(() => this.reload(undefined));
        });
    },
    deleteItem(item) {
      this.$confirm(
        this.$t("messages.deleteCalendarConfirmation").printf(item)
      ).then(value => {
        if (value) {
          this.deleting = true;
          setTimeout(() => {
            this.axios
              .delete(`calendars/${encodeURIComponent(item.id)}`)
              .then(() => {
                this.deleting = false;
                this.$toasted.info(
                  this.$t("general.deleted") + ` "${item.title}"`,
                  { icon: "check" }
                );
                this.reload();
              })
              .catch(error => {
                this.deleting = false;
                this.deleteErrorHandler(error).then(() =>
                  this.reload(undefined)
                );
              });
          }, 500);
        }
      });
    },
    onSaved(calendar) {
      this.$toasted.success(this.$t("general.saved") + ` "${calendar.title}"`, {
        icon: "check"
      });
      this.reload(undefined);
    }
  },
  mounted() {
    if (!this.loading && !this.loaded) {
      this.loadAll({
        options: this.options,
        favoriteOptions: this.favoriteOptions
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.authenticated) {
      if (this.$refs["refAdvancedSearchDialog"].showing) {
        this.$refs["refAdvancedSearchDialog"].close();
        return next(false);
      } else if (this.deleting || this.$refs["refEditDialog"].saving) {
        return next(false);
      } else if (this.$refs["refEditDialog"].showing) {
        this.$refs["refEditDialog"].close();
        return next(false);
      }
    }
    next();
  }
};
</script>

<style scoped></style>
